import { colors } from '@kmns-internal/furikake/tokens'
import { OpenInNew } from '@mui/icons-material'
import { Link, Stack, Typography } from '@mui/material'
import { buildReportHref } from 'src/features/monitoringDashboardAlpha/demo/demoReportLink'

type Props = {
  /** 紐づくレポートの UUID（無ければリンクを表示しない） */
  reportUuid?: string
  /**
   * 一時保存されたレポートか（記録中・記録中(期限切れ)）。
   * 「一時保存」はステータスとして持たせない方針のため、リンク側で補足する。
   */
  isTemporarilySaved: boolean
}

/**
 * 詳細（L2）の「該当レポート」セル。
 *
 * レポートが実在する行（実施済み・一時保存など）のみリンクを表示する。
 * 一時保存の行は、ステータス列ではなくここで「※一時保存されたレポート」と補足する。
 */
export const DetailReportLink = ({ reportUuid, isTemporarilySaved }: Props) => {
  if (!reportUuid) return null

  return (
    <Stack spacing={0.25} alignItems="flex-start">
      <Link
        href={buildReportHref(reportUuid)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="レポートを新しいタブで開く"
        // 行クリックは無効のため、リンク自身でクリックを完結させる
        onClick={event => event.stopPropagation()}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          whiteSpace: 'nowrap',
        }}
      >
        <Typography variant="body2" component="span">
          レポートはこちら
        </Typography>
        <OpenInNew fontSize="inherit" />
      </Link>
      {isTemporarilySaved && (
        <Typography variant="caption" sx={{ color: colors.text.secondary }}>
          ※一時保存されたレポート
        </Typography>
      )}
    </Stack>
  )
}
